import { useCountUp } from '@/hooks/use-count-up';

interface AnimatedStatProps {
  value: number;
  suffix?: string;
  duration?: number;
  delay?: number;
  trigger?: boolean;
  className?: string;
}

export function AnimatedStat({ 
  value, 
  suffix = '', 
  duration = 2000, 
  delay = 0,
  trigger = true,
  className = ''
}: AnimatedStatProps) {
  const { count } = useCountUp({ end: value, duration, delay, trigger });
  
  return (
    <span className={className}>
      {count}{suffix}
    </span>
  );
}
